module.exports = __webpack_public_path__ + "static/media/YM81_1.f61adf61.jpg";